"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stack = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
var _excluded = ["direction", "children", "divider", "sx", "flexWrap", "justifyContent"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// References:
// https://mui.com/components/stack/
// https://mui.com/api/stack/

var DEFAULT_DIRECTION = 'column';

// This value is multiplied by 8px and results in a 24px gutter between elements
var DEFAULT_SPACING = 3;
var Stack = exports.Stack = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? DEFAULT_DIRECTION : _ref$direction,
    children = _ref.children,
    divider = _ref.divider,
    sx = _ref.sx,
    flexWrap = _ref.flexWrap,
    justifyContent = _ref.justifyContent,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_Stack["default"], (0, _extends2["default"])({
    direction: direction,
    divider: !!divider ? /*#__PURE__*/React.createElement("span", {
      role: "separator"
    }, divider) : undefined,
    spacing: DEFAULT_SPACING,
    "data-provides": "stack",
    flexWrap: flexWrap,
    justifyContent: justifyContent
  }, rest, {
    sx: sx,
    useFlexGap: true,
    ref: ref
  }), children);
});
Stack.displayName = 'Stack';